function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _ from 'lodash';
var getAllBogoSpecialsForCart = function(items, medicalOrder, globalSpecialsSettings) {
    var bogoSpecialsHash = _.reduce(_.flatMap(items, function(item) {
        var _item_specialData;
        return (item === null || item === void 0 ? void 0 : (_item_specialData = item.specialData) === null || _item_specialData === void 0 ? void 0 : _item_specialData.bogoSpecials) || [];
    }), function(hash, bogoSpecial) {
        var bogoRewards = bogoSpecial.bogoRewards, discountToCart = bogoSpecial.discountToCart, discountBundle = bogoSpecial.discountBundle, itemsForAPrice = bogoSpecial.itemsForAPrice, menuType = bogoSpecial.menuType, specialId = bogoSpecial.specialId;
        if (menuType === 'medical' && !medicalOrder || menuType === 'recreational' && medicalOrder || (bogoRewards || []).length < 1 && !(itemsForAPrice === null || itemsForAPrice === void 0 ? void 0 : itemsForAPrice.enabled) && !(discountToCart === null || discountToCart === void 0 ? void 0 : discountToCart.enabled) && !(discountBundle === null || discountBundle === void 0 ? void 0 : discountBundle.enabled)) {
            return hash;
        }
        var existingSpecial = hash[bogoSpecial.specialId];
        if (!existingSpecial) {
            hash[specialId] = _object_spread_props(_object_spread({}, bogoSpecial), {
                discountPrecedence: bogoSpecial.discountPrecedence || globalSpecialsSettings.discountPrecedence
            });
        } else {
            hash[specialId] = _object_spread_props(_object_spread({}, existingSpecial), {
                discountPrecedence: bogoSpecial.discountPrecedence || globalSpecialsSettings.discountPrecedence,
                bogoRewards: _.uniqBy(_to_consumable_array((existingSpecial === null || existingSpecial === void 0 ? void 0 : existingSpecial.bogoRewards) || []).concat(_to_consumable_array(bogoRewards || [])), '_id')
            });
        }
        return hash;
    }, {});
    // 3.5 data format compatibility for the rest of ecomm calcs
    _.forEach(bogoSpecialsHash, function(special) {
        _.forEach(special.bogoRewards, function(reward) {
            if (!_.isNil(reward.discountAmount) && !_.isNil(reward.discountType)) {
                reward[reward.discountType] = reward.discountAmount;
            }
        });
    });
    return _.sortBy(_.values(bogoSpecialsHash), function(special) {
        if (special.isRecurring) {
            return special.recurringEndDate ? Number(special.recurringEndDate) : Infinity;
        }
        return special.endStamp ? Number(special.endStamp) : Infinity;
    });
};
export default getAllBogoSpecialsForCart;
